import React, { useState, useMemo } from "react";
import HeaderTable from "../DataTable/HeaderTable";
// import PaginationComponent from "../DataTable/Pagination";
import SearchTable from "../DataTable/Search";
import { Link } from "react-router-dom";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NepaliDatePicker } from "datepicker-nepali-reactjs";
import "./style.css";
import { changeIndexToNepali } from "../../utils";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Api from "../../services/api";
import { BSToAD } from "../../utils/dateUtils";
import ModalComp from "../modals/ModalComp";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
export default function LocalTable({
  comments,
  title,
  categories,
  current_stage,
  isLoading,
}) {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");
  const [pastDate, isPastDate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);
  const [modal3, setModal3] = useState(false);
  const toggle3 = () => setModal3(!modal3);
  // let newStage = current_stage - 1;
  const ITEMS_PER_PAGE = 10;
  let localData = "";
  let localData2 = "";
  let fiscalYear = "";
  let gnId = "";
  let ministry_id;
  if (JSON.parse(localStorage.getItem("user"))) {
    localData = JSON.parse(localStorage.getItem("user")).user.role_id;
    localData2 = JSON.parse(localStorage.getItem("user")).token;
    fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
    gnId = JSON.parse(localStorage.getItem("user")).user.ministry_id;
    ministry_id = JSON.parse(localStorage.getItem("user")).user.ministry_id;
  }

  console.log("totalItems", totalItems);

  const PostData = async (stage_id, gnid) => {
    setLoading(true);
    let response;
    if (date === "") {
      // response = await Api.submitStage({
      //   fiscal_year_id: fiscalYear,
      //   stage_id: stage_id,
      //   ministry_id: gnid,
      // });

      response = await Api.submitMinistryStage({
        fiscal_year_id: fiscalYear,
        stage_id: stage_id,
        ministry_id: gnid,
      });
    } else {
      // response = await Api.submitStage({
      //   fiscal_year_id: fiscalYear,
      //   stage_id: stage_id,
      //   ministry_id: gnid,
      //   completion_date: date,
      // });

      response = await Api.submitMinistryStage({
        fiscal_year_id: fiscalYear,
        stage_id: stage_id,
        ministry_id: gnid,
        completion_date: date,
      });
    }
    if (response.code === 200) {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      window.location.reload(true);
      setLoading(false);
    } else if (response.code === 201) {
      debugger;
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      setLoading(false);
    } else {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "प्रक्रियाको चरण", field: "name", sortable: false },
    { name: "प्रस्तावित मिति", field: "sec", sortable: false },
    { name: "सम्पन्न मिती", field: "comp", sortable: false },
    { name: "नतिजा", field: "score", sortable: false },
    { name: "कार्यहरु", field: "action", sortable: false },
  ];
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.stage_name.toLowerCase().includes(search.toLowerCase())
        // ||
        // comment.img.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  const isValidDate = (date) => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    if (date) {
      const today = Date.parse(d);
      const selectedDate = Date.parse(BSToAD(date));
      if (today > selectedDate) {
        setDate("");
        isPastDate(true);
        return false;
      }

      isPastDate(false);
      return true;
    }
  };

  const getDate = (event) => {
    isValidDate(event) && setDate(event);
  };
  const handleministry_id = (m_id, m_name) => {
    sessionStorage.setItem("m_id", m_id);
    sessionStorage.setItem("m_name", m_name);
  };
  return (
    <div className="card-layout">
      <ToastContainer autoClose={2000} />
      <div className="row">
        <div className="col mb-3 col-12 text-center">
          <div className="row table-heading">
            <div className="col-md-6">
              <h1 className="sub-heading">{title}</h1>
            </div>
            <div className="col-md-6 d-flex flex-row-reverse dataTables_search">
              <SearchTable
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          {isLoading ? (
            <h4>Loading...</h4>
          ) : commentsData === "" ? (
            <h4>विवरण उपलब्ध छैन</h4>
          ) : (
            <table className="table table-responsive local-table">
              <HeaderTable
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {/* {console.log("commentsData", commentsData)} */}
                {commentsData.map((comment, i) => (
                  <tr>
                    {/* {console.log("comment", comment)} */}
                    <th scope="row" key={comment.id}>
                      {changeIndexToNepali(++i)}
                    </th>
                    <td style={{ minWidth: "15vw", textAlign: "left" }}>
                      {comment.stage_name === "" || comment.stage_name == null
                        ? "नभएको"
                        : comment.stage_name}
                    </td>
                    <td style={{ minWidth: "15vw" }}>
                      {comment.scheduled_date === "" ||
                      comment.scheduled_date == null
                        ? "नभएको"
                        : changeIndexToNepali(
                            comment.scheduled_date.slice(0, 10)
                          )}
                    </td>
                    <td style={{ minWidth: "15vw" }}>
                      {comment.completion_date === "" ||
                      comment.completion_date == null
                        ? "नभएको"
                        : changeIndexToNepali(
                            comment.completion_date.slice(0, 10)
                          )}
                    </td>
                    <td style={{ minWidth: "15vw" }}>
                      {comment.score !== "" ? (
                        <Link
                          onClick={() =>
                            handleministry_id(ministry_id, comment.stage_name)
                          }
                          to={
                            `/score/${province_data[
                              sessionStorage.getItem("provinceId") - 1
                            ].trim()}?m_id=` +
                            comment.stage_name.trim() +
                            "&stage_id=" +
                            current_stage
                          }
                        >
                          {changeIndexToNepali(comment.score)}
                        </Link>
                      ) : current_stage > i ? (
                        "सम्पन्न"
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      className="date-wrap-nepali"
                      style={{ minWidth: "15vw" }}
                    >
                      {i === 2 && current_stage === 2 ? (
                        <>
                          {(current_stage === 3 || current_stage === 4) &&
                          (localData === 3 ||
                            localData === 4 ||
                            localData === 2) ? (
                            ""
                          ) : (
                            <Link
                              onClick={() =>
                                handleministry_id(
                                  ministry_id,
                                  comment.stage_name
                                )
                              }
                              className={
                                i === 2 && current_stage >= 2
                                  ? "btn btn-primary"
                                  : "d-none"
                              }
                              to={`/pfraform/${province_data[
                                sessionStorage.getItem("provinceId") - 1
                              ].trim()}?m_id=${comment.stage_name.trim()}`}
                            >
                              फारममा जानुहोस
                            </Link>
                          )}

                          {/* <Link
                            onClick={() =>
                              handleministry_id(ministry_id, comment.stage_name)
                            }
                            className={
                              (i === 1 || i === 2) &&
                              (current_stage === 3 || current_stage === 2) &&
                              localData === 3
                                ? "btn btn-primary"
                                : "d-none"
                            }
                            to={`/pfraform/${province_data[
                              sessionStorage.getItem("provinceId") - 1
                            ].trim()}?m_id=${comment.stage_name.trim()}`}
                          >
                            पृष्ठपोषण हेर्नुहोस्
                          </Link> */}
                          <>
                            <Button
                              id={
                                i === 2 &&
                                (current_stage === 3 || current_stage === 2) &&
                                localData === 3
                                  ? "enabled"
                                  : "d-none"
                              }
                              color="primary"
                              className={
                                localData !== 3 ? "d-none" : "btn btn-primary"
                              }
                              onClick={toggle2}
                            >
                              स्वीकृत गर्नुहोस
                            </Button>
                            <Modal
                              isOpen={modal2}
                              toggle={toggle2}
                              className={
                                "test" + i + " modal-sm modal-dialog-centered"
                              }
                            >
                              <ModalHeader toggle={toggle2}>
                                के तपाई नतिजा स्वीकृत गर्न चाहनुहुन्छ ?
                              </ModalHeader>

                              <ModalFooter>
                                <Button
                                  disabled={date === undefined ? true : false}
                                  color="primary"
                                  className="button-loader"
                                  onClick={() => {
                                    PostData(2, gnId);
                                  }}
                                >
                                  स्वीकृत गर्नुहोस
                                  {loading ? (
                                    <Loader
                                      type="Oval"
                                      color="#FFF"
                                      height={15}
                                      width={15}
                                      timeout={300000} //3 secs
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Button>{" "}
                                <Button color="secondary" onClick={toggle2}>
                                  रद्द गर्नुहोस्
                                </Button>
                              </ModalFooter>
                            </Modal>
                          </>
                        </>
                      ) : i === 1 ? (
                        <div>
                          {localData !== 2 || comment.completion_date !== "" ? (
                            ""
                          ) : (
                            <Button
                              className={"btn btn-primary"}
                              disabled={localData === 2 ? false : true}
                              color="primary"
                              onClick={toggle}
                            >
                              मिति छान्नुहोस्
                            </Button>
                          )}
                          <Modal
                            isOpen={modal}
                            toggle={toggle}
                            className={
                              "test" + i + " modal-sm modal-dialog-centered"
                            }
                          >
                            <ModalHeader toggle={toggle}>
                              मिति चयन गर्नुहोस्।
                            </ModalHeader>
                            <ModalBody>
                              <NepaliDatePicker
                                onDateSelect={getDate}
                                placeholderText="कृपया मिति चयन गर्नुहोस्।"
                              />
                            </ModalBody>
                            <ModalFooter>
                              <Button
                                className="button-loader"
                                disabled={
                                  date === undefined || date === "" || loading
                                    ? true
                                    : false || pastDate
                                }
                                color="primary"
                                onClick={() => {
                                  PostData(1, gnId);
                                }}
                              >
                                स्वीकृत गर्नुहोस
                                {loading ? (
                                  <Loader
                                    type="Oval"
                                    color="#FFF"
                                    height={15}
                                    width={15}
                                    timeout={3000} //3 secs
                                  />
                                ) : (
                                  ""
                                )}
                              </Button>{" "}
                              <Button color="secondary" onClick={toggle}>
                                रद्द गर्नुहोस्
                              </Button>
                            </ModalFooter>
                          </Modal>
                        </div>
                      ) : (
                        " "
                      )}
                      {/* <br /> */}
                      {i === 3 && current_stage === 3 ? (
                        // &&
                        // (localData === 6 || localData === 3)
                        // <>
                        //   <Button
                        //     id={
                        //       i === 3 && current_stage === 3 && localData === 3
                        //         ? "enabled"
                        //         : "d-none"
                        //     }
                        //     color="primary"
                        //     className={
                        //       localData !== 3 ? "d-none" : "btn btn-primary"
                        //     }
                        //     onClick={toggle2}
                        //   >
                        //     स्वीकृत गर्नुहोस
                        //   </Button>
                        //   <Modal
                        //     isOpen={modal2}
                        //     toggle={toggle2}
                        //     className={
                        //       "test" + i + " modal-sm modal-dialog-centered"
                        //     }
                        //   >
                        //     <ModalHeader toggle={toggle2}>
                        //       के तपाई नतिजा स्वीकृत गर्न चाहनुहुन्छ ?
                        //     </ModalHeader>

                        //     <ModalFooter>
                        //       <Button
                        //         disabled={date === undefined ? true : false}
                        //         color="primary"
                        //         className="button-loader"
                        //         onClick={() => {
                        //           PostData(2, gnId);
                        //         }}
                        //       >
                        //         स्वीकृत गर्नुहोस
                        //         {loading ? (
                        //           <Loader
                        //             type="Oval"
                        //             color="#FFF"
                        //             height={15}
                        //             width={15}
                        //             timeout={300000} //3 secs
                        //           />
                        //         ) : (
                        //           ""
                        //         )}
                        //       </Button>{" "}
                        //       <Button color="secondary" onClick={toggle2}>
                        //         रद्द गर्नुहोस्
                        //       </Button>
                        //     </ModalFooter>
                        //   </Modal>
                        // </>
                        <Link
                          onClick={() =>
                            handleministry_id(ministry_id, comment.stage_name)
                          }
                          className="btn btn-primary"
                          to={
                            `/pfraform/${
                              province_data[
                                sessionStorage.getItem("provinceId") - 1
                              ]
                            }?m_id=` + comment.stage_name.trim()
                          }
                        >
                          फारममा जानुहोस्
                        </Link>
                      ) : i === 5 ? (
                        <>
                          <Button
                            className={
                              localData !== 3 ? "d-none" : "btn btn-primary"
                            }
                            color="primary"
                            id={
                              i === 5 && current_stage === 3 && localData === 3
                                ? "enabled"
                                : "d-none"
                            }
                            onClick={toggle3}
                          >
                            स्वीकृत गर्नुहोस
                          </Button>
                          <Modal
                            isOpen={modal3}
                            toggle={toggle3}
                            className={
                              "test" + i + " modal-sm modal-dialog-centered"
                            }
                          >
                            <ModalHeader toggle={toggle3}>
                              के तपाई नतिजा स्वीकृत गर्न चाहनुहुन्छ ?
                            </ModalHeader>

                            <ModalFooter>
                              <Button
                                disabled={date === undefined ? true : false}
                                color="primary"
                                className="button-loader"
                                onClick={() => {
                                  PostData(5, gnId);
                                }}
                              >
                                स्वीकृत गर्नुहोस
                                {loading ? (
                                  <Loader
                                    type="Oval"
                                    color="#FFF"
                                    height={15}
                                    width={15}
                                    timeout={300000} //3 secs
                                  />
                                ) : (
                                  ""
                                )}
                              </Button>{" "}
                              <Button color="secondary" onClick={toggle3}>
                                रद्द गर्नुहोस्
                              </Button>
                            </ModalFooter>
                          </Modal>
                        </>
                      ) : (
                        ""
                      )}
                      {console.log("current_stage", current_stage, localData)}
                      {i === 4 ? (
                        <>
                          {current_stage === 4 || current_stage === 5 ? (
                            <div className="button-wraps">
                              <Link
                                onClick={() =>
                                  handleministry_id(
                                    ministry_id,
                                    comment.stage_name
                                  )
                                }
                                className="btn btn-primary"
                                to={
                                  `/pfraform/${
                                    province_data[
                                      sessionStorage.getItem("provinceId") - 1
                                    ]
                                  }?m_id=` + comment.stage_name.trim()
                                }
                              >
                                फारममा जानुहोस्
                              </Link>
                              <ModalComp
                                fiscalYear={fiscalYear}
                                token={localData2}
                                gnid={sessionStorage.getItem("m_id")}
                                disabled={current_stage}
                                stage_id={4}
                                localData={localData}
                              />
                            </div>
                          ) : (
                            // <Link
                            //   className="btn btn-primary"
                            //   to={`/pfraform/${sessionStorage.getItem('provinceId')}?m_id=` + ministry_id}
                            // >
                            //   फारममा जानुहोस्
                            // </Link>
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {console.log("test i", i)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
